import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

const Price = props => {
  return (
    <p className={props.styleClass}>
      {props.noDecimal ? `$${numeral(props.price).format('0,0')}` : `$${numeral(props.price).format('0,0.00')}`}
    </p>
  )
}

Price.propTypes = {
  price: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  styleClass: PropTypes.string,
  noDecimal: PropTypes.bool
}

export default Price



// WEBPACK FOOTER //
// ./src/components/price/index.js